import { Registerable } from '@baserow/modules/core/registry'
import RowHistorySidebar from '@baserow/modules/database/components/row/RowHistorySidebar.vue'
import GmailRowSidebar from '@baserow/modules/database/components/row/GmailRowSidebar.vue'
import RowApprovalsSidebar from '@baserow/modules/database/components/row/RowApprovalsSidebar.vue'

export class RowModalSidebarType extends Registerable {
  /**
   * A human readable name
   */
  getName() {
    return null
  }

  /**
   * The component to render in the sidebar
   */
  getComponent() {
    return null
  }

  /**
   * Whether the sidebar component should be shown
   */
  isDeactivated(database, table, readOnly, view) {
    return false
  }

  /**
   * When true, the sidebar type indicates
   * that it should be focused first.
   */
  isSelectedByDefault(database) {
    return false
  }

  getOrder() {
    return 50
  }

  /**
   * Returns a component to add to the actions (the top right of the sidebar).
   * If null, no action will be added.
   */
  getActionComponent() {
    return null
  }
}

export class HistoryRowModalSidebarType extends RowModalSidebarType {
  static getType() {
    return 'history'
  }

  getName() {
    return this.app.$i18n.t('rowHistorySidebar.name')
  }

  getComponent() {
    return RowHistorySidebar
  }

  isDeactivated(database, table, readOnly, view) {
    const hasPermissions = this.app.$hasPermission(
      'database.table.read_row_history',
      table,
      database.workspace.id
    )
    return !hasPermissions
  }

  isSelectedByDefault(database) {
    return true
  }

  getOrder() {
    return 10
  }
}

// Origem Flow: aba "E-mails" do modal da tarefa (Gmail dentro da tarefa).
export class GmailRowModalSidebarType extends RowModalSidebarType {
  static getType() {
    return 'gmail'
  }

  getName() {
    return this.app.$i18n.t('gmailSidebar.name')
  }

  getComponent() {
    return GmailRowSidebar
  }

  isDeactivated(database, table, readOnly, view) {
    return readOnly
  }

  getOrder() {
    return 60
  }
}

// Origem Flow: aba "Aprovação" do modal da tarefa (H2) — enviar a peça para
// o cliente aprovar por link público, acompanhar decisões e registrar
// aprovações manuais.
export class ApprovalsRowModalSidebarType extends RowModalSidebarType {
  static getType() {
    return 'approvals'
  }

  getName() {
    return this.app.$i18n.t('rowApprovals.tabName')
  }

  getComponent() {
    return RowApprovalsSidebar
  }

  isDeactivated(database, table, readOnly, view) {
    return readOnly
  }

  getOrder() {
    return 70
  }
}
